import * as React from 'react'
import { cn } from '@/lib/utils'

const ToggleGroup = React.forwardRef(({ className, value, onValueChange, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'inline-flex items-center justify-center rounded-full bg-muted p-1 text-muted-foreground',
      className
    )}
    {...props}
  >
    {React.Children.map(children, (child) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, {
          pressed: child.props.value === value,
          onPressedChange: (pressed) => {
            if (pressed && onValueChange) onValueChange(child.props.value)
          },
        })
      }
      return child
    })}
  </div>
))
ToggleGroup.displayName = 'ToggleGroup'

const ToggleGroupItem = React.forwardRef(
  ({ className, pressed, onPressedChange, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      className={cn(
        'inline-flex items-center justify-center rounded-full px-4 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
        pressed ? 'bg-background text-foreground shadow-sm' : 'bg-transparent',
        className
      )}
      onClick={() => onPressedChange && onPressedChange(!pressed)}
      {...props}
    />
  )
)
ToggleGroupItem.displayName = 'ToggleGroupItem'

export { ToggleGroup, ToggleGroupItem }
